<div [formGroup]="formGroup" [ngClass]="containerClass">
  <mat-form-field
    class="w-full"
    [appearance]="appearance"
    hideRequiredMarker="true"
  >
    <mat-label *ngIf="label">{{ label }}</mat-label>
    <mat-select
      [formControlName]="controlName"
      [placeholder]="placeholder"
      [required]="required"
    >
      <mat-option
        *ngFor="let option of options"
        [value]="option[valueKey]"
      >
        {{ option[labelKey] }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
